import ScrollSpinner from "./ScrollSpinner";

export default ScrollSpinner;
